import { debounce } from 'lodash/fp';

const POPUP_BROWSER_ACTIVITY_EVENT_NAME = 'popappbrowser:track-activity';

export const afterInactivity = (timeout, callback, { ignorePointerMove = false } = {}) => {
	const handleActivity = debounce(timeout, callback);

	handleActivity();

	document.addEventListener('keydown', handleActivity, false);
	document.addEventListener('mousedown', handleActivity, false);
	if (!ignorePointerMove) {
		document.addEventListener('mousemove', handleActivity, false);
		document.addEventListener('touchmove', handleActivity, false);
	}
	document.addEventListener('focus', handleActivity, true);
	document.addEventListener('scroll', handleActivity, true);
	document.addEventListener(POPUP_BROWSER_ACTIVITY_EVENT_NAME, handleActivity, true);

	return () => {
		handleActivity.cancel();
		document.removeEventListener('keydown', handleActivity);
		document.removeEventListener('mousedown', handleActivity);
		if (!ignorePointerMove) {
			document.removeEventListener('mousemove', handleActivity);
			document.removeEventListener('touchmove', handleActivity);
		}
		document.removeEventListener('focus', handleActivity, true);
		document.removeEventListener('scroll', handleActivity, true);
		document.removeEventListener(POPUP_BROWSER_ACTIVITY_EVENT_NAME, handleActivity, true);
	};
};

export const dispatchActionInPopAppBrowserEvent = () => {
	document.dispatchEvent(new Event(POPUP_BROWSER_ACTIVITY_EVENT_NAME));
};
